import request from '@/utils/request'
import exports from '@/utils/export'

//根据id查找
export function findById(page_url, id) {
    return request({
        url: page_url + '/' + id,
        method: 'get',
        empty2null: true
    })
}

//分页条件查找
export function findByCondition(page_url, data) {
    return request({
        url: page_url + '/search',
        method: 'post',
        data: data,
        empty2null: true
    })
}

//无分页条件查找
export function findByConditionWithoutPage(page_url, data) {
    return request({
        url: page_url + '/condition',
        method: 'post',
        data: data,
        empty2null: true
    })
}


//查找所有
export function findAll(page_url) {
    return request({
        url: page_url,
        method: 'get',
        empty2null: true
    })
}

//添加
export function add(page_url, data) {
    return request({
        url: page_url,
        method: 'post',
        data: data,
        empty2null: true
    })
}

//更新
export function update(page_url, data) {
    return request({
        url: page_url,
        method: 'put',
        data: data,
        empty2null: true
    })
}

//根据id删除
export function remove(page_url, id) {
    return request({
        url: page_url + '/' + id,
        method: 'delete',
        empty2null: true
    })
}

export function removeAll(page_url, data) {
    return request({
        url: page_url,
        method: 'delete',
        data: data,
        empty2null: true
    })
}

//get
export function get(page_url, path) {
    return request({
        url: page_url + '/' + path,
        method: 'get',
        empty2null: true
    })
}

// 按条件查询
export function query(page_url, data) {
  return request({
      url: page_url,
      method: 'get',
      params: data,
      empty2null: true
  })
}

//post
export function post(page_url, path, data) {
    return request({
        url: page_url +  (path ? ('/' + path) : ''),
        method: 'post',
        data: data,
        empty2null: true
    })
}

//分页条件查找
export function search(page_url, data) {
    return request({
        url: page_url + '/search',
        method: 'post',
        data: data,
        empty2null: true
    })
}

//export
export function exportExcel(page_url, path, data) {
    return exports({
        url: page_url + '/' + path,
        method: 'post',
        data: data,
        responseType: 'blob',
        empty2null: true
    })
}

//form
export function postForm(page_url, path, data) {
    return request({
        url: page_url + '/' + path,
        method: 'post',
        data: data,
        headers: { 'Content-Type': 'multipart/form-data' },
        empty2null: true
    })
}

//获取还款账号
export function findProperties(page_url, data) {
    return request({
        url: page_url + '/findProperties',
        method: 'post',
        data: data,
        empty2null: true
    })
}

//添加还款账号
export function addProperties(page_url, data) {
    return request({
        url: page_url + '/addProperties',
        method: 'post',
        data: data,
        empty2null: true
    })
}

//添加放款还款账号
export function addAccount(page_url, data) {
    return request({
        url: page_url + '/addAccount',
        method: 'post',
        data: data,
        empty2null: true
    })
}

//获取放款还款账号列表
export function findAccountList(page_url, data) {
    return request({
        url: page_url + '/findAccountList',
        method: 'post',
        data: data,
        empty2null: true
    })
}

//删除放款还款账号
export function deleteAccount(page_url, data) {
    return request({
        url: page_url + '/deleteAccount',
        method: 'post',
        data: data,
        empty2null: true
    })
}

